export default __webpack_public_path__ + "static/media/B_lopetus8.694a1a2c.mp3";